import { render, staticRenderFns } from "./exclusiveClients.vue?vue&type=template&id=7b1d7ec0&scoped=true&"
import script from "./exclusiveClients.vue?vue&type=script&lang=js&"
export * from "./exclusiveClients.vue?vue&type=script&lang=js&"
import style0 from "./exclusiveClients.vue?vue&type=style&index=0&id=7b1d7ec0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b1d7ec0",
  null
  
)

export default component.exports